import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import MallLogo from '../../../assets/img/ayala-malls-logo.svg'
import Brand from '../../../assets/img/brand.webp'
import Background from '../../../assets/img/layoutBackgroundVariant.webp'
import LayoutBackgroundImage from '../../../assets/img/layout-background.svg'
import Facebook from '../../../assets/img/social/fb.png'
import Instagram from '../../../assets/img/social/in.png'
import Youtube from '../../../assets/img/social/yt.png'
import TncModalLink from '../../home/TncModalLink/TncModalLink'
import PrivacyModalLink from '../../home/PrivacyModalLink/PrivacyModalLink'
import ContactUsModal from '../../home/ContactUsModal/ContactUsModal'

import { doContactUsSubmit } from '../../../controllers/ContactUs'

import media from '../../../services/generateMediaQueries'
import { getRedirectUri } from '../../../services/data/sso'

const LogoVariant = styled.img.attrs({ src: MallLogo })`
  width: 7rem;
  align-self: center;

  ${media.lessThan('small')`
  display:none;
  `}
`

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const StyledLayout = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2rem 0;

  &::before {
    content: ' ';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 85%, rgba(91, 190, 175, 0.15) 100%), url('${Background}');
    z-index: -1;
    background-size: cover;
    background-position: center top;
  }
  
  ${media.lessThan('small')`
    padding: 0;

    &::before {
      // height: 4.5rem;   
      height: 6rem;
      background: url('${Background}');
      background-size: cover;
      // background-position: left -39px;
      background-position: center -70px;
    }
  `}
`

const Header = styled.div`
  margin: 0 auto 2rem;
  text-align: center;

  ${media.lessThan('small')`
    // height: 4.5rem;
    height: 6rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ variant }) => {
      if (variant === 'sso') return `display:none;`
    }}
  `}
`

const Card = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;
  min-height: ${({ minHeight }) => minHeight || '480px'};
  border-radius: var(--border-radius-container);
  padding: ${({ hasCarousel }) => (hasCarousel ? `4rem 0` : `4rem`)};
  
  padding-top: 12rem;
  margin: 0 auto;

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('${LayoutBackgroundImage}');
    background-color: rgba(255, 255, 255, 0.95);
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: -1;
    border-radius: var(--border-radius-container);
    transform: translate3d(0, 0, 0);
  }
  ${({ variant }) => {
    if (variant === 'sso') {
      return css`
        ${media.lessThan('small')`
        max-width: unset;
        min-height: 480px;
        margin: 0;
        padding-top: 40vw;
        `}
        ${media.lessThan('xsmall')`
        padding-top: 45vw;
        `}
      `
    } else {
      return css`
        ${media.lessThan('small')`
      flex: 1;
      border-radius: 0;
      padding:${({ hasCarousel }) => (hasCarousel ? `2rem 0` : ` 2rem`)};
      max-width: unset;
      background-color: rgba(255, 255, 255, 1);
  
      &::before {
        border-radius: 0;
      }
    `}
      `
    }
  }}
 
`

const Logo = styled.img`
  position: absolute;
  top: 3rem;
  height: 4rem;
  left: 4rem;

  ${media.lessThan('small')`
${({ variant }) => {
  if (variant !== `sso`) {
    return css`
      display: none;
    `
  }
}}

`}
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;

  margin-top: 2rem;

  padding: 2rem;

  font-size: 0.875rem;
  color: #ffffff;

  ${media.lessThan('small')`
    background: #ffffff;
    color: var(--color-fg);

    width: 100%;

    margin: 0;
    padding: 1.5rem;
    font-size: 0.75rem;

    flex-direction: column;
    align-items: center;
    ${({ variant }) => {
      if (variant !== `sso`) {
        return css`
          display: none;
        `
      }
    }}
  `}
`

const FooterLinksContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${media.lessThan('small')`
    align-items: center;
  `}
`

const FooterLinks = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  ${media.lessThan('small')`
    justify-content: center;
  `}
`

const StyledLinkItem = styled.li`
  margin-right: 1rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;

  &:last-child {
    margin-right: 0;
  }
`

const StyledTncModalLink = styled(TncModalLink)`
  color: #ffffff;
  text-decoration: none;

  ${media.lessThan('small')`
    color: var(--color-fg);
  `}
`

const StyledPrivacyModalLink = styled(PrivacyModalLink)`
  color: #ffffff;
  text-decoration: none;

  ${media.lessThan('small')`
    color: var(--color-fg);
  `}
`

const Copyright = styled.p`
  margin: 0;
`

const FooterSocialsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${media.lessThan('small')`
    margin-top: 1rem;
    align-items: center;
  `}
`

const FooterSocials = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 120px;
  margin-bottom: 0.5rem;
`

const SocialImage = styled.div.attrs(props => ({
  style: { WebkitMaskImage: `url('${props.image}')` },
}))`
  background-color: #ffffff;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;

  width: 35px;
  height: 35px;

  ${media.lessThan('small')`
    background-color: var(--color-fg);
  `}
`

const PoweredBy = styled.p`
  margin: 0;
  margin-bottom: 5px;
  letter-spacing: var(--letter-spacing-wider);
`

const StyledLink = styled(Link)`
  color: #ffffff !important;
  text-decoration: none;

  &:hover {
    color: var(--color-primary-hover) !important;
  }

  ${media.lessThan('small')`
    color: var(--color-fg) !important;
  `}
`

const FooterLink = styled.a`
  cursor: pointer;
  color: #ffffff !important;
  text-decoration: none;

  &:hover {
    color: var(--color-primary-hover) !important;
  }

  ${media.lessThan('small')`
    color: var(--color-fg) !important;
  `}
`

function Layout(props) {
  const { children, variant, minHeight, location } = props
  const [displayContactUs, setDisplayContactUs] = React.useState(false)

  const isSSo = !!getRedirectUri(location.search)

  const newVariant = isSSo ? 'sso' : variant
  const hasCarousel = variant === 'has-carousel'

  return (
    <LayoutContainer>
      <StyledLayout variant={newVariant}>
        <LogoVariant />
        <Header variant={newVariant} />
        <Card
          variant={newVariant}
          hasCarousel={hasCarousel}
          minHeight={minHeight}
        >
          <Link to="/">
            <Logo src={Brand} variant={newVariant} alt="Ayala Malls" />
          </Link>
          {children}
        </Card>
      </StyledLayout>
      <Footer variant={newVariant}>
        <FooterLinksContainer>
          <FooterLinks>
            <StyledLinkItem>
              <StyledLink to="/main/malls">Our Malls</StyledLink>
            </StyledLinkItem>
            <StyledLinkItem>
              <StyledLink to="/promos-and-events">Events</StyledLink>
            </StyledLinkItem>
            <StyledLinkItem>
              <FooterLink onClick={() => setDisplayContactUs(true)}>
                Contact Us
              </FooterLink>
            </StyledLinkItem>
            <StyledLinkItem>
              <StyledPrivacyModalLink>Privacy Notice</StyledPrivacyModalLink>
            </StyledLinkItem>
            <StyledLinkItem>
              <StyledTncModalLink tab="tnc">
                Terms and Conditions
              </StyledTncModalLink>
            </StyledLinkItem>
          </FooterLinks>
          <Copyright>
            Copyright © 2019 AyalaLand Malls, Inc. All Rights Reserved
          </Copyright>
        </FooterLinksContainer>
        <FooterSocialsContainer>
          <FooterSocials>
            <FooterLink
              href="https://www.facebook.com/AyalaMalls360"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImage image={Facebook} />
            </FooterLink>
            <FooterLink
              href="https://www.instagram.com/iloveayalamalls/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImage image={Instagram} />
            </FooterLink>
            <FooterLink
              href="https://www.youtube.com/channel/UCkZGCcsk7YZ_QcgP6hwcJrQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImage image={Youtube} />
            </FooterLink>
          </FooterSocials>
          <PoweredBy>
            <FooterLink
              href="https://www.whitecloak.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by White Cloak Technologies Inc.
            </FooterLink>
          </PoweredBy>
        </FooterSocialsContainer>
      </Footer>
      <ContactUsModal
        show={displayContactUs}
        onSubmit={doContactUsSubmit()}
        shouldCloseOnOverlayClick={false}
        onClose={() => setDisplayContactUs(false)}
      />
    </LayoutContainer>
  )
}

Layout.defaultProps = {
  children: null,
  location: {},
}

Layout.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
}

export default Layout
